var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArrayUtils } from "../../../utilities/arrays";
import { autoinject } from "aurelia-dependency-injection";
var NotificationCenterEntryComposer = /** @class */ (function () {
    function NotificationCenterEntryComposer() {
        this.vmWithModelSet = [];
    }
    NotificationCenterEntryComposer.prototype.register = function (vmWithModel, replaceIfExists) {
        if (replaceIfExists === void 0) { replaceIfExists = true; }
        var index = ArrayUtils.findIndex(this.vmWithModelSet, function (x) { return x.type == vmWithModel.type; });
        if (index < 0) {
            this.vmWithModelSet.push(vmWithModel);
        }
        else if (replaceIfExists) {
            this.unregister(vmWithModel);
            this.vmWithModelSet.push(vmWithModel);
        }
    };
    NotificationCenterEntryComposer.prototype.get = function (type) {
        return this.vmWithModelSet.filter(function (x) { return x.type == type; })[0];
    };
    NotificationCenterEntryComposer.prototype.unregister = function (vmWithModel) {
        var index = ArrayUtils.findIndex(this.vmWithModelSet, function (x) { return x.type == vmWithModel.type; });
        if (index >= 0) {
            this.vmWithModelSet.splice(index, 1);
        }
    };
    NotificationCenterEntryComposer = __decorate([
        autoinject
    ], NotificationCenterEntryComposer);
    return NotificationCenterEntryComposer;
}());
export { NotificationCenterEntryComposer };
var NotificationEntryViewModelPath = /** @class */ (function () {
    function NotificationEntryViewModelPath() {
    }
    return NotificationEntryViewModelPath;
}());
export { NotificationEntryViewModelPath };
